import "./banner/Banner.css";
import Banner from "./banner/Banner";
import KeyFeatureComponent from "./KeyFeatureComponent/KeyFeatureComponent";
import Our_Services from "./Our_Services/Our_Services";
import Insurance from "./Insurance/Insurance";
import Our_Partners from "./Our_Partners/Our_Partners";
import Advantage_of_Loan from "./Advantage_of_Loan/Advantage_of_Loan";
import Calculate_Personal_Loan_Emi from "../Common_Component/Calculate_Personal_Loan_Emi/Calculate_Personal_Loan_Emi";
import AddvertiseBanner from "./addvertiseBanner/AddvertiseBanner";
import CompareCollegeFaq from "../CompareCollegeFaq/CompareCollegeFaq";
import Trust_badges from "./trust_badges/Trust_badges";
import Criteria_details from "./criteria_details/Criteria_details";

function Home() {
  return (
    <>
      <div id="Banner">
        <Banner />
      </div>

      <Criteria_details />



      <div id="key_feature">
        <KeyFeatureComponent />
      </div>



      {/* <div id="Insurance">
        <Insurance />
      </div> */}

      <div id="calculate_loan">
        <Calculate_Personal_Loan_Emi heading="Know Your Personal Loan Eligibility
        and EMI"  />
      </div>

      <Our_Partners />

      <div >
        <AddvertiseBanner />
      </div>

      <Advantage_of_Loan />

      <div id="our_service">
        <Our_Services />
      </div>

      {/* <Trust_badges /> */}

      <CompareCollegeFaq />
    </>
  );
}

export default Home;
